export default __webpack_public_path__ + "static/media/UiArchiveInactive.363188c8.svg";